import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetexRegulationsQueryQueryVariables = Types.Exact<{
  queryArgs: Types.QueryArgsInput;
}>;


export type GetexRegulationsQueryQuery = { __typename?: 'Query', getexRegulationsQuery: { __typename?: 'GetexRegulationsInfinityResults', getexIds: Array<string>, getexFilterOptions: { __typename?: 'GetexFilterOptions', regulationNumberOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, regulationTitleOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, regulationStatusOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, vehicleCategoryOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }> }, getexRegulationsBatch: Array<{ __typename?: 'GetexRegulation', id: string, regulationNumber: string, regulationTitle: string, regulationStatus: string, dateEffective?: any | null, keywords: Array<string>, vehicleCategories: Array<string>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any, fileName: string, originalFileName?: string | null } }> | null }> } };

export type GetexRegulationsNextQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsInput;
}>;


export type GetexRegulationsNextQuery = { __typename?: 'Query', getexRegulationsNext: Array<{ __typename?: 'GetexRegulation', id: string, regulationNumber: string, regulationTitle: string, regulationStatus: string, dateEffective?: any | null, keywords: Array<string>, vehicleCategories: Array<string>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any, fileName: string, originalFileName?: string | null } }> | null }> };

export type GetexSortOrdersQueryVariables = Types.Exact<{
  sortArgs: Types.SortArgsInput;
}>;


export type GetexSortOrdersQuery = { __typename?: 'Query', getexSortOrders: Array<string> };

export type UpdateGetexRegulationMutationVariables = Types.Exact<{
  input: Types.UpdateGetexRegulationInput;
}>;


export type UpdateGetexRegulationMutation = { __typename?: 'Mutation', updateGetexRegulation: { __typename?: 'UpdateGetexRegulationPayload', getexRegulation?: { __typename?: 'GetexRegulation', id: string, regulationNumber: string, regulationTitle: string, regulationStatus: string, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, dateEffective?: any | null, keywords: Array<string>, vehicleCategories: Array<string>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, message?: string | null, reapprovingMessage?: string | null, dueDate?: any | null, dueDateInProcess?: any | null } } | null } };

export type SyncLatestGetexRegulationsMutationVariables = Types.Exact<{
  syncAttachments: Types.Scalars['Boolean'];
}>;


export type SyncLatestGetexRegulationsMutation = { __typename?: 'Mutation', syncLatestGetexRegulations: { __typename?: 'SyncLatestGetexRegulationsPayload', syncLatestGetexRegulationsResult?: { __typename?: 'SyncLatestGetexRegulationsResult', success: boolean, message?: string | null } | null } };


export const GetexRegulationsQueryDocument = gql`
    query GetexRegulationsQuery($queryArgs: QueryArgsInput!) {
  getexRegulationsQuery(queryArgs: $queryArgs) {
    getexIds
    getexFilterOptions {
      regulationNumberOptions {
        optionKey
        name
      }
      regulationTitleOptions {
        optionKey
        name
      }
      regulationStatusOptions {
        optionKey
        name
      }
      keywordOptions {
        optionKey
        name
      }
      vehicleCategoryOptions {
        optionKey
        name
      }
    }
    getexRegulationsBatch {
      id
      regulationNumber
      regulationTitle
      regulationStatus
      dateEffective
      keywords
      vehicleCategories
      attachments {
        attachmentId
        file {
          uri
          fileName
          originalFileName
        }
      }
    }
  }
}
    `;

/**
 * __useGetexRegulationsQueryQuery__
 *
 * To run a query within a React component, call `useGetexRegulationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexRegulationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexRegulationsQueryQuery({
 *   variables: {
 *      queryArgs: // value for 'queryArgs'
 *   },
 * });
 */
export function useGetexRegulationsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>(GetexRegulationsQueryDocument, options);
      }
export function useGetexRegulationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>(GetexRegulationsQueryDocument, options);
        }
export type GetexRegulationsQueryQueryHookResult = ReturnType<typeof useGetexRegulationsQueryQuery>;
export type GetexRegulationsQueryLazyQueryHookResult = ReturnType<typeof useGetexRegulationsQueryLazyQuery>;
export type GetexRegulationsQueryQueryResult = Apollo.QueryResult<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>;
export const GetexRegulationsNextDocument = gql`
    query GetexRegulationsNext($nextArgs: NextArgsInput!) {
  getexRegulationsNext(nextArgs: $nextArgs) {
    id
    regulationNumber
    regulationTitle
    regulationStatus
    dateEffective
    keywords
    vehicleCategories
    attachments {
      attachmentId
      file {
        uri
        fileName
        originalFileName
      }
    }
  }
}
    `;

/**
 * __useGetexRegulationsNextQuery__
 *
 * To run a query within a React component, call `useGetexRegulationsNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexRegulationsNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexRegulationsNextQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *   },
 * });
 */
export function useGetexRegulationsNextQuery(baseOptions: Apollo.QueryHookOptions<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>(GetexRegulationsNextDocument, options);
      }
export function useGetexRegulationsNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>(GetexRegulationsNextDocument, options);
        }
export type GetexRegulationsNextQueryHookResult = ReturnType<typeof useGetexRegulationsNextQuery>;
export type GetexRegulationsNextLazyQueryHookResult = ReturnType<typeof useGetexRegulationsNextLazyQuery>;
export type GetexRegulationsNextQueryResult = Apollo.QueryResult<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>;
export const GetexSortOrdersDocument = gql`
    query GetexSortOrders($sortArgs: SortArgsInput!) {
  getexSortOrders(sortArgs: $sortArgs)
}
    `;

/**
 * __useGetexSortOrdersQuery__
 *
 * To run a query within a React component, call `useGetexSortOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexSortOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexSortOrdersQuery({
 *   variables: {
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useGetexSortOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>(GetexSortOrdersDocument, options);
      }
export function useGetexSortOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>(GetexSortOrdersDocument, options);
        }
export type GetexSortOrdersQueryHookResult = ReturnType<typeof useGetexSortOrdersQuery>;
export type GetexSortOrdersLazyQueryHookResult = ReturnType<typeof useGetexSortOrdersLazyQuery>;
export type GetexSortOrdersQueryResult = Apollo.QueryResult<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>;
export const UpdateGetexRegulationDocument = gql`
    mutation UpdateGetexRegulation($input: UpdateGetexRegulationInput!) {
  updateGetexRegulation(input: $input) {
    getexRegulation {
      id
      regulationNumber
      regulationTitle
      regulationStatus
      disassemblyStatus
      dateEffective
      keywords
      vehicleCategories
      workflow {
        status
        message
        reapprovingMessage
        dueDate
        dueDateInProcess
      }
    }
  }
}
    `;
export type UpdateGetexRegulationMutationFn = Apollo.MutationFunction<UpdateGetexRegulationMutation, UpdateGetexRegulationMutationVariables>;

/**
 * __useUpdateGetexRegulationMutation__
 *
 * To run a mutation, you first call `useUpdateGetexRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGetexRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGetexRegulationMutation, { data, loading, error }] = useUpdateGetexRegulationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGetexRegulationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGetexRegulationMutation, UpdateGetexRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGetexRegulationMutation, UpdateGetexRegulationMutationVariables>(UpdateGetexRegulationDocument, options);
      }
export type UpdateGetexRegulationMutationHookResult = ReturnType<typeof useUpdateGetexRegulationMutation>;
export type UpdateGetexRegulationMutationResult = Apollo.MutationResult<UpdateGetexRegulationMutation>;
export type UpdateGetexRegulationMutationOptions = Apollo.BaseMutationOptions<UpdateGetexRegulationMutation, UpdateGetexRegulationMutationVariables>;
export const SyncLatestGetexRegulationsDocument = gql`
    mutation SyncLatestGetexRegulations($syncAttachments: Boolean!) {
  syncLatestGetexRegulations(input: {syncAttachments: $syncAttachments}) {
    syncLatestGetexRegulationsResult {
      success
      message
    }
  }
}
    `;
export type SyncLatestGetexRegulationsMutationFn = Apollo.MutationFunction<SyncLatestGetexRegulationsMutation, SyncLatestGetexRegulationsMutationVariables>;

/**
 * __useSyncLatestGetexRegulationsMutation__
 *
 * To run a mutation, you first call `useSyncLatestGetexRegulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncLatestGetexRegulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncLatestGetexRegulationsMutation, { data, loading, error }] = useSyncLatestGetexRegulationsMutation({
 *   variables: {
 *      syncAttachments: // value for 'syncAttachments'
 *   },
 * });
 */
export function useSyncLatestGetexRegulationsMutation(baseOptions?: Apollo.MutationHookOptions<SyncLatestGetexRegulationsMutation, SyncLatestGetexRegulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncLatestGetexRegulationsMutation, SyncLatestGetexRegulationsMutationVariables>(SyncLatestGetexRegulationsDocument, options);
      }
export type SyncLatestGetexRegulationsMutationHookResult = ReturnType<typeof useSyncLatestGetexRegulationsMutation>;
export type SyncLatestGetexRegulationsMutationResult = Apollo.MutationResult<SyncLatestGetexRegulationsMutation>;
export type SyncLatestGetexRegulationsMutationOptions = Apollo.BaseMutationOptions<SyncLatestGetexRegulationsMutation, SyncLatestGetexRegulationsMutationVariables>;